import { useState } from 'react';

const About = () => {
    return (
      
        <section className="research-area">
            
        <h1 className="bold lg-font"></h1>
        
        
     </section>
    )
}

export default About